import React, { createContext, useContext } from 'react'
import {
  SystemStatusBannerState,
  useSystemStatusBanner
} from './useSystemStatusBanner'

// Shared so the banner stack and the top-bar pill react to the same dismissal
// state (dismissing in one updates the other). Provided once in the app shell.
const SystemStatusContext = createContext<SystemStatusBannerState | null>(null)

export const SystemStatusProvider = ({
  children
}: {
  children: React.ReactNode
}) => {
  const value = useSystemStatusBanner()
  return (
    <SystemStatusContext.Provider value={value}>
      {children}
    </SystemStatusContext.Provider>
  )
}

export const useSystemStatusContext = (): SystemStatusBannerState => {
  const ctx = useContext(SystemStatusContext)
  if (!ctx) {
    throw new Error(
      'useSystemStatusContext must be used within a SystemStatusProvider'
    )
  }
  return ctx
}
